import { render, staticRenderFns } from "./RoleChangeUserRoles.vue?vue&type=template&id=2c37fb4e&scoped=true"
import script from "./RoleChangeUserRoles.vue?vue&type=script&lang=ts"
export * from "./RoleChangeUserRoles.vue?vue&type=script&lang=ts"
import style0 from "./RoleChangeUserRoles.vue?vue&type=style&index=0&id=2c37fb4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c37fb4e",
  null
  
)

export default component.exports